import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a6753fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeyup"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "agent-action-description--title" }, "Agent Description", -1))
const _hoisted_3 = { class: "agent-action-description--content" }
const _hoisted_4 = { class: "agent-action-description--footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Submit")

import { ref } from 'vue';
import { IncrediField, IncrediButton } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { SelectedAgent } from './AgentActionMenu.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentActionSetDescription',
  props: {
    agentsList: null
  },
  emits: ["submit"],
  setup(__props: any, { emit }: { emit: ({ (e: 'submit', value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  agentsList: SelectedAgent[];
}


// eslint-disable-next-line no-unused-vars


const isBulk = props.agentsList?.length > 1;
const hostCommentValue = props.agentsList[0].hostComment || '';
const allAgentsHasSameValue = props.agentsList.every(item => item.hostComment === hostCommentValue);
const descValue = ref((isBulk && allAgentsHasSameValue) || !isBulk ? hostCommentValue : '');

const submitAction = () => {
  emit('submit', descValue.value);
};

return (_ctx: any,_cache: any) => {
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "agent-action-description",
        onKeyup: _withKeys(submitAction, ["enter"])
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(IncrediField), {
            modelValue: descValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((descValue).value = $event)),
            clearable: true,
            name: "agent-action-description",
            maxlength: 100,
            size: "tiny",
            label: "Add a description"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(IncrediButton), {
            "data-testid": "agent-action-description-submit",
            size: "tiny",
            onClick: submitAction
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ], 40, _hoisted_1)), [
        [_directive_incredi_focus_trap, 'agent-set-description']
      ])
    ]),
    _: 1
  }))
}
}

})